import { Alert, Grid } from '@mui/material';
import { VERIFICATION_PHRASES } from '@/consts/phrases/verificationPhrases';
import { usePhrase } from '@/hooks';

export const PendingReview = () => {
    const { t } = usePhrase();
    return (
        <Grid size={12} sx={{ mb: 2 }}>
            <Alert severity="warning">{t(VERIFICATION_PHRASES.VERIFICATION_IN_PROGRESS)}</Alert>
        </Grid>
    );
};
